import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.70096 2.25C5.27831 1.25 6.72169 1.25 7.29904 2.25L9.89711 6.75C10.4745 7.75 9.75278 9 8.59808 9H3.40192C2.24722 9 1.52554 7.75 2.10289 6.75L4.70096 2.25Z",
		fill: "#06748D"
	})
});
const ForwardRef = forwardRef(SvgCaretUp);
export default ForwardRef;
